<template>
  <div class="question-grid">

    <div>
      <div>
        <div  class="star-grid"
              v-for="(starsItem, index) of getStarsData"
              :key="index">
          <div class="star-class">
            <StarRating :star-size="14"
                        class="star-rating"
                        active-color="black"
                        :rating="starsItem.points"
                        :fixed-points="0"
                        :increment="1"
                        :read-only="true"
                        :show-rating="false"
                        :disabled="true" />
          </div>
          <div>
            <SimpleBarGraph :star="starsItem" />
          </div>
        </div>
      </div>

      <div>
        <div class="avg-grid">
          <div class="avg-text-header">Average:</div>
          <div class="avg-class">
            <div  class="avg-line"
                  v-for="(average, index) of getAverageData"
                  :key="index">
              <StarRating :star-size="12" v-if="getAverageData.length > 0"
                          class="star-avg"
                          :active-color="average.color"
                          inactive-color="#FFF"
                          :rating="average.rating"
                          :fixed-points="1"
                          :increment="0.1"
                          :read-only="true"
                          :show-rating="false"
                          :disabled="true" />
              <div class="avg-text2">{{ average.rating === undefined ? $t("Webportal.NoResults") : (Math.round(average.rating * 10) / 10).toFixed(1) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <img  class="brand-logo"
          :src="imageUrl">

  </div>
</template>

<script>
import StarRating from "vue-star-rating";
import SimpleBarGraph from '@/components/MarketReports/SimpleBarGraph.vue';

export default {
  components: {
    StarRating, SimpleBarGraph
  },
  props: {
    chartColor:     { type: String, default: 'red' },
    data:           { type: Object, required: true },
    waves:          { type: Array, required: true },
  },
  computed: {
    imageUrl() {
      if (this.data && this.data.logo)
        return process.env.BASE_URL + `api/media/image?id=${this.data.logo}`;
    },
    getStarsData() {
      if (this.data && this.data.stars)
        return this.data.stars;
      return [];
    },
    getAverageData() {
      if (this.data && this.data.average)
        return this.data.average;
      return [];
    }
  }
}
</script>

<style lang="scss" scoped>

.question-grid {
  display: grid;
  grid-template-columns: 1fr 5rem;
}
.question-text {
  display: inline-block;
  max-width: 20rem;
  min-height: 4rem;
  padding-left: 5rem;
  overflow-wrap: break-word
}

.star-grid:not(:last-child) {
  border-bottom: 1px solid black;
}

.star-grid, .avg-grid {
  display: grid;
  grid-template-columns: 5rem 10rem;
  min-height: 2.0rem;
}

.star-class {
  border-right: 1px solid black;
  max-width: 5.5rem;
}

.avg-grid {
  font-size: 10px;
  padding-top: 2px;
}

.avg-text {
  margin-top: 9px;
  font-size: 12px;
  margin-left: 4px;
}

.avg-text-header {
  padding-top: 16px;
  border-right: 1px solid black;
  font-size: 12px;
  margin-left: 4px;
  font-weight: bold;
}

.avg-class {
  max-width: 12.5rem;
  line-height: 0.5;

  span.vue-star-rating-rating-text {
    font-size: 19px;
  }
}

.avg-line {
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 1.0rem;
  max-width: 11rem;
}

.avg-text2 {
  margin-top: 6px;
  font-size: 12px;
  margin-left: 4px;
  overflow-wrap: break-word;
}

.brand-logo {
  max-height: 5rem;
  max-width: 8rem;
  margin-right: auto;
  margin-left: auto;
  padding-left: 1rem;
}

.star-avg {
  padding: 0px;
  line-height: 0.6;
}

.star-rating {
  padding: 6px;
}
</style>
